import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { TypeFinanceAccountsResponse } from "@/types";

async function fetchTypeFinanceAccounts(): Promise<TypeFinanceAccountsResponse> {
  const response = await httpRequest.get<TypeFinanceAccountsResponse>(
    `/finance-type-accounts`
  );
  return response.data;
}

export function useFetchTypeFinanceAccountsQuery() {
  const typeAccountsResponseQuery = useQuery({
    queryKey: ["type-accounts"],
    queryFn: () => fetchTypeFinanceAccounts(),
    keepPreviousData: true,
  });

  return {
    ...typeAccountsResponseQuery,
    data: typeAccountsResponseQuery?.data,
  };
}
